import { useState, useEffect } from 'react'
import { siteApi } from '@/services/api'
import { isSuccess } from '@/services/types'
import type { ContactInfo } from '@/services/types'

let cachedContact: ContactInfo | null = null
let fetchPromise: Promise<ContactInfo | null> | null = null

async function fetchContact(): Promise<ContactInfo | null> {
  if (cachedContact) return cachedContact
  if (fetchPromise) return fetchPromise
  fetchPromise = siteApi.getContact().then(res => {
    if (isSuccess(res)) {
      cachedContact = res.data
      return res.data
    }
    return null
  }).finally(() => {
    fetchPromise = null
  })
  return fetchPromise
}

export function useContactInfo(): ContactInfo | null {
  const [contact, setContact] = useState<ContactInfo | null>(cachedContact)

  useEffect(() => {
    if (cachedContact) {
      setContact(cachedContact)
      return
    }
    fetchContact().then(data => {
      if (data) setContact(data)
    })
  }, [])

  return contact
}
